module.exports = __webpack_public_path__ + "img/ke-zhen.0d014c95.png";